import { EchoRoutes } from '../router.types';

export const echoRoutes: EchoRoutes = {
  echoMessages: `${process.env.NEXT_PUBLIC_ORCA_HOST}/influencers/messages`,
  echoPayments: `${process.env.NEXT_PUBLIC_ORCA_HOST}/payments`,
  echoEditProfile: `${process.env.NEXT_PUBLIC_ORCA_HOST}/influencers/editprofile`,
};
